
import {
  AUTH_BANNER_SHOW,
  AUTH_BANNER_CLEAR,
} from "../AuthBanner/AuthBannerActionTypes";
import { AuthBannerAction, AuthBannerState } from "@model/Authentication.model";


const INITIAL_STATE: AuthBannerState = {
  message: null,
  returnPath: null,
};

export const AuthBannerReducer = (
  state: AuthBannerState = INITIAL_STATE,
  action: AuthBannerAction
): AuthBannerState => {
  switch (action.type) {
    case AUTH_BANNER_SHOW:
      return {
        message: action.payload?.message ?? null,
        returnPath: action.payload?.returnPath ?? null,
      };

    case AUTH_BANNER_CLEAR:
      return {
        message: null,
        returnPath: null,
      };

    default:
      return state;
  }
};
